export default __webpack_public_path__ + "static/media/foreal_header.680722cf.jpg";